import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/scribd': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M42.3 252.7c-16.1-19-24.7-45.9-24.8-79.9 0-100.4 75.2-153.1 167.2-153.1 98.6-1.6 156.8 49 184.3 70.6l-50.5 72.1-37.3-24.6 26.9-38.6c-36.5-24-79.4-36.5-123-35.8-50.7-0.8-111.7 27.2-111.7 76.2 0 18.7 11.2 20.7 28.6 15.6 23.3-5.3 41.9 0.6 55.8 14 26.4 24.3 23.2 67.6-0.7 91.9-29.2 29.5-85.2 27.3-114.8-8.4zM360 258.6c33.9 40.4 36.8 138.2-20.3 189.6-39.2 33.6-82.2 44.1-133.6 44.1-70.3 0.3-138.2-25.4-190.7-72.2l-15.4-13.8 60.8-71.8 35.6 27.4-33.7 39.4c41.7 30.9 92.2 47.5 144.1 47.3 61.9 0 104.7-23.5 121.4-64.4 0.9-4.2 1.4-8.4 1.4-12.7 0-18.7-11.2-20.7-28.6-15.6-23.3 5.3-42.2-0.5-56.3-14.4-12.4-11.3-19.1-27.5-18.4-44.3-0.6-39.2 32.4-69.2 70.5-67.2 24.3-0.8 47.7 9.8 63.2 28.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/scribd.js
// module id = 1003
// module chunks = 0